<template>
  <div class="page" v-cloak>
    <!-- 导航 -->
    <van-nav-bar :border="false" left-arrow fixed title="百福币明细" class="user_balance_log_nav_bar" :z-index="9999" :style="'background: #ff5000; color:#FFFFFF;'" id="nav-bar" @click-left="onClickLeft"></van-nav-bar>

    <!-- 列表 -->
    <div class="list">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
        <text-row-bfb v-for="(item, index) in list" :bfb-data="item" :key="index"></text-row-bfb>
      </van-list>
    </div>

  </div>
</template>

<script type="text/babel">
import TextRowBfb from "@/components/text-row-bfb/text-row-bfb.vue";
export default {
  name: "bfb-log-list",
  components: { TextRowBfb },
  props: {},
  data() {
    return {
      list: [
        // {
        //   money: "金额",
        //   type:1,// "1=充值 2=消费",
        //   remark: "备注",
        //   created_time: "日期",
        // },
        // {
        //   money: "金额",
        //   type:2,// "1=充值 2=消费",
        //   remark: "备注",
        //   created_time: "日期",
        // },
      ],
      pageNum: 1,
      pageSize: 10,
      loading: false,
      finished: false,
    };
  },
  watch: {},
  created() {},
  mounted() {
    // this.getList();
  },
  methods: {
    getList() {
      this.$toast.loading();
      let _this = this;
      let data = {
        page: _this.pageNum,
        limit: _this.pageSize,
      };
      _this.$post("/api/bfb_list", data, data).then((res) => {
        // console.log(res.data);
        this.$toast.clear();
        _this.loading = false; // 加载状态结束

        if (res.data.code == 0) {
          // console.log(res.data.data);
          let lists = res.data.data;

          if (lists && lists.length > 0) {
            if (_this.pageNum == 1) {
              _this.list = [];
              _this.list = lists;
            } else {
              _this.list = _this.list.concat(lists);
            }
            _this.pageNum++;
            if (lists.length < _this.pageSize) {
              _this.finished = true; // 数据全部加载完成
            }
          } else {
            _this.finished = true; // 数据全部加载完成
          }
        } else {
          _this.$toast.fail(res.data.message);
          _this.finished = true;
        }
      });
    },

    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss">
.user_balance_log_nav_bar {
  .van-nav-bar__content {
    .van-icon,
    .van-nav-bar__title {
      color: #fff;
    }
  }
  .van-nav-bar__right {
    .van-nav-bar__text {
      color: #fff;
    }
  }
}
</style>
<style lang="scss" scoped>
.page {
  height: 100%;
  width: 100%;
  padding: 46px 0;
  background-color: #f9f9f9;

  .list {
    padding: 0 0 30px;
  }
}
.header-table {
  height: 54px;
  width: 100%;
  background-color: #fff;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
}
.pop-tips {
  text-align: left;
  padding: 0 10px;
  position: relative;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 27px;
  color: #454f63;
  letter-spacing: 1px;
  .in-text::after {
    content: "";
    position: absolute;
    width: 3px;
    height: 13px;
    left: 0;
    top: 8px;
    background: #4374ff;
    z-index: 1;
    border-radius: 0 10px 10px 0;
  }
}
.radio {
  text-align: center;
  font-size: 15px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 25px;
  color: #666666;
  display: inline-block;
  padding: 5px 10px;
  background: #eeeeee;
  // border-radius: 5px;

  border-radius: 15px;
  margin: 5px 10px;
  border: 1px solid #eeeeee;
}
.radio-active {
  background: rgba(0, 168, 192, 0.1);
  border: 1px solid #2fa4ff;
  color: #4374ff;
}
.time-block {
  // position: relative;
  height: 50px;
  width: 100%;
  // border: 1px solid #eee;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 15px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 26px;
  color: #cccccc;
  .bo {
    border-bottom: 1px solid #4374ff !important;
    color: #4374ff;
  }
  .input-block {
    width: 125px;
    height: 50px;
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }
  .input-block-a {
    width: 125px;
    height: 50px;
    border-bottom: 1px solid #4374ff;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    color: #4374ff;
  }
}
.picker-time {
  margin-top: 20px;
  border: solid 1px #eee;
}
.btn-block {
  // position: absolute;
  // bottom: 10px;
  // left: 0;
  margin-top: 25px;
  width: 100%;
  height: 47px;
  padding: 0 15px;
  background-color: #ffffff;
  border-top: 1px solid #f9f9f9;

  box-shadow: 0px -5px 5px rgba(69, 79, 99, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  .btn-left {
    width: 50%;
    height: 40px;
    background: #2fa4ff;
    opacity: 1;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 20px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn-right {
    width: 50%;
    height: 40px;
    background: #4374ff;
    opacity: 1;

    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 20px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.click:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}
.btnC:active {
  background-color: rgba(255, 80, 0, 0.7) !important;
}
</style>
 